module.exports = __webpack_public_path__ + "media/svg-new/support-purple-astronauta-c3fc4a8a.svg";